import { mediaQuery } from './media-query';

jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '767',
      () => {
        // Mobile do anything
        console.log('Hola soy Footer Mobile');
        footerMenu ();
      }
    );
  
  });

//Menú footer en movil + texto readmore
function footerMenu () {
    let title = jQuery('.footer .footer-middle-row .elementor-heading-title');        
    let menu = jQuery('.footer .footer-middle-row .elementor-nav-menu--dropdown, .footer .footer-middle-row .elementor-widget-text-editor');
    menu.hide();
    
    title.on('click', function(){
        jQuery(this).closest('.elementor-widget-wrap').find('.elementor-nav-menu--dropdown, .elementor-widget-text-editor').slideToggle();
        if(!jQuery(this).hasClass('is-open')){
            //$(this)
            jQuery(this)
            .addClass('is-open')
            .next('div').slideToggle();
        }else{
            jQuery(this)
            .removeClass('is-open')
            .next('div').toggle();
        }
    }); 
}
